import React from "react";
import { Form, Row, Col } from "react-bootstrap";
import { Controller } from "react-hook-form";
import NumberFormat from "react-number-format";

const ClientSelector = ({
  control,
  register,
  watch,
  errors,
}) => {
  const watchedSendAutomations = watch("send_automations");

  return (
    <div className="client-selector-container">
      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Nome do Cliente *</Form.Label>
            <Form.Control
              {...register("client_name", {
                required: watchedSendAutomations
                  ? "Nome do cliente é obrigatório"
                  : false,
              })}
              placeholder="Digite o nome do cliente"
            />
            {errors.client_name && (
              <span className="text-danger small">
                {errors.client_name.message}
              </span>
            )}
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Telefone *</Form.Label>
            <Controller
              name="client_phone"
              control={control}
              rules={{
                required: watchedSendAutomations
                  ? "Telefone é obrigatório"
                  : false,
              }}
              render={({ field }) => (
                <NumberFormat
                  format="(##) #####-####"
                  className={`form-control ${
                    errors.client_phone ? "is-invalid" : ""
                  }`}
                  placeholder="(00) 00000-0000"
                  onValueChange={(values) => {
                    field.onChange(values.value);
                  }}
                  value={field.value || ""}
                />
              )}
            />
            {errors.client_phone && (
              <span className="text-danger small">
                {errors.client_phone.message}
              </span>
            )}
          </Form.Group>
        </Col>
      </Row>
    </div>
  );
};

export default ClientSelector;
